














































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { isOptionalGoodsPackage } from '@/api/shoppingMall'
import { PackageListDto, RuleListDto, SelectSKUListDto } from '@/api/buyCar'
import {
  getCyGoodsSpecificationList,
  ShopGoodsInfoDto,
  addStoreShoppingCart,
  isGoodsValid
} from '@/api/industryMall'
import { isContained } from '@/components/PackageSelector/packageSelector'
import { Action, Getter } from 'vuex-class'
import StepperTemp from '@/components/StepperTemp/index.vue'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
@Component({
  name: 'PackageSelector',
  components: { StepperTemp }
})
export default class PackageSelector extends Vue {
  @Getter providerId!: string // 店铺编号
  @Getter companyId!: string
  @Getter info!: LoginReturnDataDto
  @Action setPreOrderParams!: (val) => void
  @Prop({ default: () => {} }) storeInfo?: any

  showRules = false
  orderQuantity = 1
  ruleType = '3' // ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单,默认值3 '4'购物车选择规格后确定
  // 商品规格列表
  ruleList: RuleListDto[] = []
  // 后端返回的套餐列表
  packageList: PackageListDto[] = []
  // 套餐列表信息
  skuList: PackageListDto[] = []
  currentSkuList: string[][] = []
  /*  将sku规格值的ID，即 packageId，组成一个数组并且字典排序，以及将该sku所对应的index存入数组，供点击后查询sku */
  valueIdSortAndIndex: { valueIdSort: string[] }[] = []

  selectItemList: SelectSKUListDto[] = [] // 用于设置规格是否为禁用状态
  selectValue = '' // 已选规格code拼接字符串，用于对应套餐列表中packageName
  selectValueList: string[] = [] // 已选规格code的数组形式，必须已ruleList列表的顺序作为相应下标
  mainImageUrl = '' // 商品主图
  weight = '' // 商品重量
  goodsId = '' // 商品id
  goodsName = '' // 商品名称
  goodsPrice: number | string = '' // 商品单价
  packageCount = 0 // 商品
  selectPackageInfo: PackageListDto = {}
  maxNum = 100000
  minNum = 1
  isMultiSpec = false // isMultiSpec	是否为多规格
  defaultInfo: ShopGoodsInfoDto = {} // 默认的后端接口返回的数据，用于取消掉规格之后的数据重置
  activityPrice = '' // 活动价格

  isMulPrice = true // 是否含有多个价格参数

  @Watch('selectValueList', { deep: true, immediate: true })
  changeSelectValue(val: string[]) {
    if (val.length === 0 || val.includes('')) {
      console.log('123')
      this.isMulPrice = true

      // console.log('isMultiSpec-----', this.isMultiSpec)
      console.log('defaultInfo-----', this.defaultInfo)
      // 数据重置
      this.mainImageUrl = this.defaultInfo.goodsMainImage
      this.weight = ''
      // if (this.defaultInfo.activityPriceMin) {
      //   this.goodsPrice = this.defaultInfo.activityPriceMin
      // } else {
        this.goodsPrice = this.defaultInfo.goodsPriceMin
      // }
      this.maxNum = 10000
      this.minNum = 1
      this.orderQuantity = 1
      this.selectValue = ''
      // 展示价格起
      // if (!this.isMultiSpec && this.defaultInfo.activityPriceMin) {
      if (this.defaultInfo.activityPriceMin) {
        this.activityPrice = this.defaultInfo.activityPriceMin
      } else {
        this.activityPrice = ''
      }
    } else {
      this.isMulPrice = false
      const selectJoinStr = val.join(',')
      console.log('selectJoinStr', selectJoinStr)
      this.selectPackageInfo = this.packageList.find((item) => {
        return item.packageName === selectJoinStr
      })
      console.log('selectPackageInfo', this.selectPackageInfo)
      this.mainImageUrl = this.selectPackageInfo.mainImageUrl
      this.weight = this.selectPackageInfo.weight
      // this.goodsPrice = this.selectPackageInfo.orderPrice
      if (this.selectPackageInfo.activityPrice) {
        this.activityPrice = this.selectPackageInfo.activityPrice
      } else {
        this.activityPrice = ''
      }
      this.goodsPrice = this.selectPackageInfo.marketPrice
      // this.maxNum = this.selectPackageInfo.goodsCount
      this.minNum = this.selectPackageInfo.minimum || 1
      this.orderQuantity = this.selectPackageInfo.minimum || 1
      this.selectValue = selectJoinStr
    }
  }
  // 是否展示‘起’字
  get isMorePrice() {
    return (
      (Number(this.defaultInfo.goodsPriceMax) > Number(this.defaultInfo.goodsPriceMin) || Number(this.defaultInfo.activityPriceMax) > Number(this.defaultInfo.activityPriceMin)) &&
      this.isMulPrice
    )
  }

  /* 校验商品是否上架 */
  async isGoodsValid() {
    const param = {
      shopId: this.storeInfo.companyId,
      goodsId: this.defaultInfo.goodsId
    }
    return isGoodsValid(param).then((res) => {
      return res.data.isValid
    })
  }

  /**
   * 获取套餐规格列表数据
   * */
  getGoodsRuleList() {
    const params = {
      // customerId: this.companyId,
      // shopId: this.providerId,
      storeId: this.$route.query.storeId,
      goodsId: this.goodsId
    }
    // return getGoodsSpecificationList(params).then((res) => {
    return getCyGoodsSpecificationList(params).then((res) => {
      let goodType = res.data.goodsSpecificationList || []
      let packageList = res.data.packageList || []
      this.packageList = packageList
      /* 处理单规格时，默认选中第一个套餐列表中的数据 */
      // console.log('isMultiSpec',this.isMultiSpec)
      if (!this.isMultiSpec) {
        // console.log('selectPackageInfo',this.packageList[0])
        this.selectPackageInfo = this.packageList[0]
        this.weight = this.selectPackageInfo.weight
        // this.maxNum = this.selectPackageInfo.maximum
        // this.maxNum = this.selectPackageInfo.goodsCount
        this.minNum = this.selectPackageInfo.minimum || 1
        this.orderQuantity = this.selectPackageInfo.minimum || 1
      }

      if (packageList && packageList.length > 0) {
        packageList.forEach((item) => {
          // @ts-ignore
          item.skuTypes = item.packageName.split(',')
        })
        this.skuList = packageList
      }
      this.init()

      if (goodType && goodType.length > 0) {
        goodType.forEach((items, index) => {
          items.specValueList.forEach((item) => {
            if (this.selectValueList && this.selectValueList.length > 0) {
              if (this.selectValueList[index] === item.attrValueCode) {
                item.selected = true
              } else {
                item.selected = false
              }
            } else {
              // @ts-ignore
              item.selected = false
            }
            // @ts-ignore
            item.disabled = true
          })
        })
        this.ruleList = goodType
        if (!this.selectValueList || this.selectValueList.length <= 0) {
          this.selectValueList = new Array(this.ruleList.length).fill('')
        }
      }
      this.initGoodType()
    })
  }

  /**
   * sku数据初始化
   */
  init() {
    const valueIdSortAndIndex = []
    const currentSkuList = this.skuList.map((item) => {
      const valueIdSort = []
      item.skuTypes.map((skuTypesItem) => {
        valueIdSort.push(skuTypesItem)
      })
      /* 将sku规格值的ID，即 propertyId，组成一个数组并且字典排序，以及将该sku所对应的index存入数组，供点击后查询sku */
      valueIdSortAndIndex.push({ valueIdSort: valueIdSort.sort() })
      return item.skuTypes
    })

    this.$set(this.$data, 'currentSkuList', currentSkuList)
    this.$set(this.$data, 'valueIdSortAndIndex', valueIdSortAndIndex)
  }

  /**
   * 判断套餐中是否能匹配到已选规格的套餐
   */
  initGoodType() {
    const currentSkuList = this.currentSkuList.flat(Infinity)
    this.ruleList.forEach((items) => {
      items.specValueList.forEach((item) => {
        for (let i = 0; i < currentSkuList.length; i++) {
          if (item.attrValueCode == currentSkuList[i]) {
            // @ts-ignore
            item.disabled = false
            break
          }
        }
      })
    })
  }

  /**
   * 选择每个规格，判断对应的库存
   * @param ruleId 规格列表id
   * @param specId 规格项列表id
   * @param el 规格列表中具体某一项的列表数据
   * @param ruleIndex 规格列表下标
   * @param specIndex 规格项列表下标
   */
  handleClickSpecs(ruleId, specId, el, ruleIndex, specIndex) {
    // this.isMulPrice = false
    const { selectItemList } = this // 已选规格

    if (el.disabled) {
      return
    }
    // 处理selected的逻辑
    if (!el.selected) {
      this.ruleList[ruleIndex].specValueList.forEach((item) => {
        item.selected = false
      })
      this.ruleList[ruleIndex].specValueList[specIndex].selected = true
      this.$set(this.selectValueList, ruleIndex, specId)
      // 选中项中有同组元素，替换
      selectItemList.forEach((item, xSelectedIndex) => {
        if (item.index === ruleIndex) {
          selectItemList.splice(xSelectedIndex, 1)
        }
      })
      selectItemList.push({
        ruleId,
        ruleTypeId: specId,
        index: ruleIndex,
        i: specIndex
      })
    } else {
      // 取消选中并删除选中项中数据
      this.ruleList[ruleIndex].specValueList[specIndex].selected = false
      this.$set(this.selectValueList, ruleIndex, '')
      selectItemList.forEach((item, xSelectedIndex) => {
        if (item.ruleTypeId === specId && item.ruleId === ruleId) {
          selectItemList.splice(xSelectedIndex, 1)
        }
      })
    }
    this.$set(this.$data, 'selectItemList', selectItemList)

    this.handleDisable()
  }

  private handleDisable() {
    const { selectItemList } = this // 已选规格
    // 取出组ID
    const xSelectedGrounpIds = []
    selectItemList.forEach((item) => {
      xSelectedGrounpIds.push(item.ruleId)
    })

    // 处理disabled的逻辑
    if (selectItemList.length == 0) {
      // 选中属性为空，重新初始化数据
      this.initGoodType()
    } else {
      // 拿所有规格属性（即goodsTypeList）的每一项分别与已选中的数据（即selectItemList）的每一项，组成一个比较项，与现有库存比较，找到存在的可点项
      this.ruleList.forEach((goodsType, goodsTypeIndex) => {
        goodsType.specValueList.forEach((prop, propIndex) => {
          if (!prop.selected) {
            prop.disabled = true
          }
          // 本次循环数据
          const pushData = {
            ruleId: goodsType.specificationId,
            ruleTypeId: prop.attrValueCode,
            index: goodsTypeIndex,
            i: propIndex
          }
          if (xSelectedGrounpIds.indexOf(goodsType.specificationId) > -1) {
            // 当前循环的规格的组ID在已选规格中，删除同组规格，用当前规格替换后去与库存比较
            const sel = selectItemList.slice() // 用一个新变量接受数据，防止修改源数据
            const indexSplice = xSelectedGrounpIds.indexOf(
              goodsType.specificationId
            )
            sel.splice(indexSplice, 1, pushData)
            this.optionsHandle(sel, pushData)
          } else {
            //  当前循环规格组ID不在已选规格中，添加当前规格到复制出来的已选数组中，循环比较
            const sel = selectItemList.slice()
            sel.push(pushData)
            this.optionsHandle(sel, pushData)
          }
        })
      })
    }
  }

  /**
   * 在现有套餐列表中查找是否有可选项，可选的置为可点击
   * @param selArr
   * @param pushData
   */
  optionsHandle(selArr, pushData) {
    const propertyIds = []
    // 将当前比较项的属性ID提取
    selArr.map((item) => {
      propertyIds.push(item.ruleTypeId)
    })
    // 在现有套餐列表中查找是否有可选项，可选的置为可点击
    this.valueIdSortAndIndex.map((item) => {
      if (isContained(item.valueIdSort, propertyIds)) {
        this.ruleList[pushData.index].specValueList[pushData.i].disabled = false
      }
    })
  }

  /**
   * ruleType 规格弹窗类型
   * detailInfo 商品详情信息
   * selectList 已选择规格数据
   * packageList
   * */
  show(data: {
    ruleType?: string
    detailInfo?: ShopGoodsInfoDto
    selectList?: string[]
    defaultInfo?: ShopGoodsInfoDto
    packageList?: PackageListDto[]
  }) {
    this.showRules = true
    this.ruleType = data.ruleType
    this.selectItemList = []
    this.packageList = data.packageList
    if (data.detailInfo) {
      // this.selectPackageInfo = Object.assign(this.selectPackageInfo, data.detailInfo)
      this.goodsId = data.detailInfo.goodsId
      this.goodsName = data.detailInfo.goodsName
      this.mainImageUrl = data.detailInfo.goodsMainImage
      this.goodsPrice = data.detailInfo.goodsPrice
      // this.goodsPrice = data.detailInfo.goodsPriceMin
      this.packageCount = data.detailInfo.packageCount
      // isMultiSpec	是否为多规格	Boolean
      this.isMultiSpec = data.detailInfo.isMultiSpec as boolean
    }
    this.defaultInfo = data.defaultInfo || {}
    if (data.selectList && data.selectList.length > 0) {
      this.selectValueList = data.selectList
    } else {
      this.selectValueList = []
    }
    this.getGoodsRuleList().then(() => {
      this.ruleList.forEach((rule, ruleIndex) => {
        rule.specValueList.forEach((specItem, specIndex) => {
          if (this.selectValueList.includes(specItem.attrValueCode)) {
            this.selectItemList.push({
              ruleId: rule.specificationId,
              ruleTypeId: specItem.attrValueCode,
              index: ruleIndex,
              i: specIndex
            })
          }
        })
      })
      this.handleDisable()
    })
  }

  /* 所选套餐校验,暂时没有这个功能 */
  isOptionalGoods() {
    const obj = {
      goodsPackageList: [
        {
          customerId: this.companyId,
          goodsPackageId: this.selectPackageInfo.packageId,
          shopId: this.storeInfo.companyId
        }
      ]
    }
    return new Promise<void>((resolve, reject) => {
      isOptionalGoodsPackage(obj)
        .then((res) => {
          const data = res.data
          // const data = {
          //     isOptional: false,
          //     rejectType: 'InvalidPackage'
          // }
          if (data.isOptional) {
            resolve()
          } else {
            /* rejectType
          * NonOrderable:当前商品不可订货
          InvalidGoods：商品状态不为上架
          InvalidPackage：套餐状态不为上架
          * */
            if (data.rejectType === 'InvalidPackage') {
              this.$dialog
                .alert({
                  message: '商品规格不存在，请重新选择'
                })
                .then(() => {
                  //    刷新该商品【商品详情】界面
                  this.$emit('reloadInfo')
                  this.showRules = false
                })
            } else if (
              data.rejectType === 'NonOrderable' ||
              data.rejectType === 'InvalidGoods'
            ) {
              this.$dialog
                .alert({
                  message: '商品过期不存在'
                })
                .then(() => {
                  //    关闭弹窗，返回上一界面并刷新。刷新刷新
                  window.sessionStorage.setItem('refresh', '1')
                  this.$router.back()
                  this.showRules = false
                })
            }
          }
        })
        .catch(() => {})
    })
  }

  /**
   * 关闭购物车弹窗,检验已选套餐状态，根据校验状态做不同处理
   * */
  closeRules() {
    /*
    * 判断1、点击按钮，判断“商品规格”是否已选择完整（确定商品套餐）；
    ①若“商品规格”未选择完整，则直接关闭弹窗；
    ②若“商品规格”已选择完整，则进入判断2。
    判断2、判断商品状态；
    ①若商品状态为“上架”，则进入判断3；
    ②若商品状态不为“上架”，则弹出提示“商品过期不存在”，点击弹窗“确定”按钮，关闭弹窗，返回上一界面并刷新。
    判断3、判断该商品的分类是否为当前登录客户所属“客户级别”下“可订商品分类”；
    ①若不是则弹出提示“商品过期不存在”，点击弹窗“确定”按钮，返回上一界面并刷新；
    ②若是则进入判断4。
    判断4、判断“商品套餐”状态；
    ①若商品套餐状态为“上架”，则【商品详情】界面“商品价格”、“商品规格”、“商品重量”字段取值为当前登录客户下所选“商品套餐”的值；
    ②若商品套餐状态不为“上架”，则弹出提示“商品规格不存在，请重新选择”，点击弹窗“确定”按钮，刷新该商品【商品详情】界面。

    * */
    if (!this.isFullRule()) {
      // 数量重置
      this.$emit('getSelectPackageInfo', {}, [])
      return (this.showRules = false)
    }

    // this.isOptionalGoods().then(() => {
    //     则【商品详情】界面“商品价格”、“商品规格”、“商品重量”字段取值为当前登录客户下所选“商品套餐”的值；
    this.$emit(
      'getSelectPackageInfo',
      this.selectPackageInfo,
      this.selectValueList
    )
    this.showRules = false
    // }).catch(() => { })
  }

  /**
   * 判断是否选择了全部的规格项
   * */
  isFullRule() {
    return this.selectValueList && !this.selectValueList.includes('')
  }

  /**
   * 加入购物车
   * */
  async joinBuyCar() {
    const isValid = await this.isGoodsValid()
    if (!isValid) {
      this.$dialog
        .alert({
          message: '商品过期不存在'
        })
        .then(() => {
          this.$router.go(-1)
        })
      return
    }
    // debugger
    if (!this.isFullRule()) {
      console.log('123')
      return this.$toast('请选择规格')
    }
    console.log(this.selectValueList, this.selectPackageInfo.packageId)
    let params = {
      // 合作方id
      partnerCompanyId: this.info.partnerCompanyId,
      goodsId: this.goodsId,
      packageId: this.selectPackageInfo.packageId,
      storeId: this.storeInfo.companyId,
      orderQuantity: +this.orderQuantity
    }
    addStoreShoppingCart(params)
      .then((res) => {
        if (res.code === '000000') {
          this.$toast.success({
            message: '已添加到购物车中',
            duration: 1000,
            onClose: () => {
              this.$emit(
                'getSelectPackageInfo',
                this.selectPackageInfo,
                this.selectValueList
              )
              this.showRules = false
            }
          })
        } else if (res.code === '000002') {
          const data = res.data
          // const data = {
          //     isOptional: false,
          //     rejectType: 'InvalidPackage'
          // }
          /* rejectType
            * NonOrderable:当前商品不可订货
            InvalidGoods：商品状态不为上架
            InvalidPackage：套餐状态不为上架
            * */
          if (data.rejectType === 'InvalidPackage') {
            this.$dialog
              .alert({
                message: '商品规格不存在，请重新选择'
              })
              .then(() => {
                //    刷新该商品【商品详情】界面
                this.$emit('reloadInfo')
                this.showRules = false
              })
          } else if (
            data.rejectType === 'NonOrderable' ||
            data.rejectType === 'InvalidGoods'
          ) {
            this.$dialog
              .alert({
                message: '商品过期不存在'
              })
              .then(() => {
                //    关闭弹窗，返回上一界面并刷新。刷新刷新
                window.sessionStorage.setItem('refresh', '1')
                this.$router.back()
                this.showRules = false
              })
          }
        }
        this.$eventBus.$emit('refreshCar')
      })
      .catch(() => {})
  }

  /**
   * 立即下单
   * */
  async placeOrder() {
    const isValid = await this.isGoodsValid()
    if (!isValid) {
      this.$dialog
        .alert({
          message: '商品过期不存在'
        })
        .then(() => {
          this.$router.go(-1)
        })
      return
    }
    if (!this.isFullRule()) {
      return this.$toast('请选择规格')
    }

    // this.isOptionalGoods().then(() => {
    // const data: GetPreOrderInfoParamsDto = {
    //   customerId: this.companyId,
    //   shopPackageList: [
    //     {
    //       companyId: this.providerId,
    //       goodsPackageList: [
    //         {
    //           goodsId: this.goodsId,
    //           packageId: this.selectPackageInfo.packageId,
    //           orderQuantity: this.orderQuantity
    //         }
    //       ]
    //     }
    //   ]
    // }
    console.log(this.orderQuantity)
    const data = {
      companyId:this.companyId,
      storeList: []
    }
    data.storeList = [
      {
        storeId: this.defaultInfo.storeId,
        // storeName: 'CS214店铺',
        // storeLogo:
        //   'cyosstest/63eb5a48d5e8c83f4c81fa0b/2023-02-15/d0f7a738-41ab-4d3d-8bca-10cc72e47083.jpg',
        storeName: this.storeInfo.companyName,
        storeLogo: this.storeInfo.logoUrl,
        goodsPackageList: [
          {
            goodsId: this.goodsId,
            packageId: this.selectPackageInfo.packageId,
            orderQuantity: this.orderQuantity
          }
        ]
      }
    ]

    /* 存储获取预提交订单信息入参数据 */
    this.setPreOrderParams(data)
    // this.$router.push('/submitOrder')
    this.$router.push('/submitMallOrder')
    // }).catch(() => { })
  }
  /**
   * 选择规格之后回到购物车，带回选择的规格和单价
   */
  async changeRuleSure() {
    const isValid = await this.isGoodsValid()
    if (!isValid) {
      this.$dialog
        .alert({
          message: '商品过期不存在'
        })
        .then(() => {
          this.$router.go(-1)
        })
      return
    }
    if (!this.isFullRule()) {
      return this.$toast('请选择规格')
    }
    this.$emit(
      'getSelectPackageInfo',
      this.selectPackageInfo,
      this.selectValueList
    )
    this.showRules = false
  }

  /**
   * 购物车商品数量改变时
   * @param value 加购商品数量
   */
  changeQuantity(value) {
    console.log('value----',value);
    
    this.orderQuantity = value
  }
}
